import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { providerDegrees } from '../mockData/provider-degrees-data';

const ProviderDegreesApi = [
  rest.get(`${API_ROOT}degrees`, (req, res, ctx) => res(ctx.json(providerDegrees))),
  rest.get(`${API_ROOT}degrees/${providerDegrees[0].id}`, (req, res, ctx) => res(ctx.json(providerDegrees[0]))),
  rest.put(`${API_ROOT}degrees/${providerDegrees[0].id}`, (req, res, ctx) => res(ctx.json(providerDegrees[0]))),
  rest.post(`${API_ROOT}degrees`, (req, res, ctx) => res(ctx.json(providerDegrees[1]))),
  rest.delete(`${API_ROOT}degrees/${providerDegrees[0].id}`, (req, res, ctx) => res(ctx.json(providerDegrees[0]))),
];

export default ProviderDegreesApi;
